"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfStipendDto = instanceOfStipendDto;
exports.StipendDtoFromJSON = StipendDtoFromJSON;
exports.StipendDtoFromJSONTyped = StipendDtoFromJSONTyped;
exports.StipendDtoToJSON = StipendDtoToJSON;
exports.StipendDtoToJSONTyped = StipendDtoToJSONTyped;
const StipendType_1 = require("./StipendType");
/**
 * Check if a given object implements the StipendDto interface.
 */
function instanceOfStipendDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('stipendType' in value) || value['stipendType'] === undefined)
        return false;
    if (!('amount' in value) || value['amount'] === undefined)
        return false;
    return true;
}
function StipendDtoFromJSON(json) {
    return StipendDtoFromJSONTyped(json, false);
}
function StipendDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'stipendType': (0, StipendType_1.StipendTypeFromJSON)(json['stipendType']),
        'amount': json['amount'],
        'qualified': json['qualified'] == null ? undefined : json['qualified'],
    };
}
function StipendDtoToJSON(json) {
    return StipendDtoToJSONTyped(json, false);
}
function StipendDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'stipendType': (0, StipendType_1.StipendTypeToJSON)(value['stipendType']),
        'amount': value['amount'],
        'qualified': value['qualified'],
    };
}
//# sourceMappingURL=StipendDto.js.map